var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEstatesSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0834 2.66699H12.75C11.2794 2.66699 10.0834 3.86299 10.0834 5.33366V12.7817L3.80737 19.0577C3.62096 19.2441 3.49402 19.4817 3.4426 19.7403C3.39117 19.9989 3.41758 20.2669 3.51847 20.5105C3.61936 20.7541 3.79022 20.9623 4.00943 21.1089C4.22864 21.2554 4.48637 21.3336 4.75004 21.3337V28.0003C4.75004 28.3539 4.89052 28.6931 5.14057 28.9431C5.39061 29.1932 5.72975 29.3337 6.08337 29.3337H27.4167C27.7703 29.3337 28.1095 29.1932 28.3595 28.9431C28.6096 28.6931 28.75 28.3539 28.75 28.0003V5.33366C28.75 3.86299 27.554 2.66699 26.0834 2.66699ZM15.4167 26.667H7.41671V19.219L11.4167 15.219L15.4167 19.219V26.667ZM26.0834 26.667H18.0834V21.3337C18.3473 21.3342 18.6055 21.2564 18.8251 21.11C19.0448 20.9636 19.2159 20.7552 19.3169 20.5114C19.4179 20.2675 19.4442 19.9991 19.3924 19.7403C19.3406 19.4815 19.2131 19.2439 19.026 19.0577L12.75 12.7817V5.33366H26.0834V26.667Z",
    fill: "#2D4BF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4163 8H18.083V10.6667H15.4163V8ZM20.7497 8H23.4163V10.6667H20.7497V8ZM20.7497 13.3747H23.4163V16H20.7497V13.3747ZM20.7497 18.6667H23.4163V21.3333H20.7497V18.6667ZM10.083 20H12.7497V22.6667H10.083V20Z",
    fill: "#2C333A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstatesSvg);
export default __webpack_public_path__ + "static/media/estates_svg.8d1ef8851cca3304c2017e1cd04f04d7.svg";
export { ForwardRef as ReactComponent };